export const ITEM_PRICE = {
    RETAIL_PRCE:0,
    WHOLESALE_PRICE:1,
    LEAST_PRICE:2
}